var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      show: _vm.visible,
      title: _vm.isEditing
        ? _vm.$t("Editar Estoque Mínimo")
        : _vm.$t("Adicionar Estoque Mínimo"),
      width: "500px",
    },
    on: {
      save: _vm.save,
      hidden: function ($event) {
        _vm.visible = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "FormulateForm",
              { ref: "form", on: { submit: _vm.save } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "mb-2", attrs: { md: "12" } },
                      [
                        _c("e-store-combo", {
                          attrs: {
                            required: false,
                            "only-active-options": true,
                            label: _vm.$t("Loja"),
                            placeholder: _vm.$t("Geral"),
                          },
                          model: {
                            value: _vm.form.storeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "storeId", $$v)
                            },
                            expression: "form.storeId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "mb-2", attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "minimum-stock",
                            type: "number",
                            label: _vm.$t("Estoque Mínimo"),
                            validation: "required|min:0",
                          },
                          model: {
                            value: _vm.form.minimumStock,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "minimumStock", _vm._n($$v))
                            },
                            expression: "form.minimumStock",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }